import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { getAuthState } from '@/stores/auth.store';

export const Route = createFileRoute('/_awaiting-approval')({
  beforeLoad: async ({ location }) => {
    const { accessToken, user } = getAuthState();

    if (!accessToken) {
      throw redirect({
        to: '/login',
        search: { redirect: location.href },
      });
    }

    // Not pending — send them onward through the rest of the chain.
    if (user && user.accountStatus !== 'PENDING') {
      if (!user.emailVerified) {
        throw redirect({ to: '/verify-email' });
      }
      if (!user.accountSetupComplete) {
        throw redirect({ to: '/account-setup' });
      }
      throw redirect({ to: '/' });
    }
  },
  component: AwaitingApprovalLayout,
});

function AwaitingApprovalLayout() {
  return <Outlet />;
}
